/*
 * @Author: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @Date: 2025-03-18 14:54:22
 * @LastEditors: liulipeng liulipeng@longfor.com
 * @LastEditTime: 2025-09-23 09:28:54
 * @FilePath: /qd-c4-yunjing-web/src/views/oss/alarm/constans.ts
 * @Description: 报警常量
 */
export const PROCESS_OPTIONS = [

  {
    label: '未发送',
    value: '0',
  },
  {
    label: '未发送(点位存在未完成工单)',
    value: '5',
  },
  {
    label: '已发送',
    value: '1',
  },
  {
    label: '发送失败',
    value: '2',
  },
  {
    label: '报警屏蔽',
    value: '3',
  },
  {
    label: '报警隔离',
    value: '4',
  }
];

export const ALARM_LEVEL_OPTIONS = [
  {
    label: '中级',
    value: '1',
  },
  {
    label: '高级',
    value: '2',
  },
  {
    label: '超高级',
    value: '3',
  }
];
export const BIZ_SOURCE_OPTIONS = [
  {
    label: '能源',
    value: '1',
  },
  {
    label: '运行',
    value: '2',
  },
  {
    label: '安全',
    value: '3',
  },
  {
    label: '物联',
    value: '4',
  }

];

export const ALARM_STATUS_INFO = ['未发送(点位存在未完成工单)', '已发送', '发送失败', '报警屏蔽', '报警隔离'];
export const TITLE_LIST = ['实时告警列表', '历史告警列表', '隔离告警列表'];
export const REASON_LIST = ['现场改造装修', '暂无备品备件', '维修周期较长', '其他'];
